// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-inner-section[data-v-19b81223] {\n  padding-top: 32px;\n  margin-top: 32px;\n  border-top: 1px solid #e2e2e2;\n}\n.panel-header[data-v-19b81223] {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 32px;\n  align-items: flex-start;\n}\n", ""]);
// Exports
module.exports = exports;
